import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box, Paper, Table, TableRow,
    Grid, TableHead,
    TableBody,
    TableCell, TextField,
    TableContainer,
    Button, Tooltip,
    FormControl, Checkbox, ListItemText,
    InputLabel, Select, MenuItem, CircularProgress, Typography,
    DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import SnackbarMessage from "../../../../components/snackBar/snackBar";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CustomButton from "../../../../components/buttons/customButton";
import SingleSelect from "../../../../components/selections/singleSelect";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const STATUS_OPTIONS = [
    { value: 1, label: "Completed" },
    { value: 2, label: "Waiting" },
    { value: 3, label: "Scheduled" },
    { value: 4, label: "Cancelled" },
];

const prescriptionMedicineDayTimings = [
    { label: "Morning", value: 1 },
    { label: "Afternoon", value: 2 },
    { label: "Evening", value: 3 }
];

const medicineTypes = [
    { label: "tablet", value: 1 },
    { label: "syrup", value: 2 },
    { label: "Ointment ", value: 3 }
];

const tabletData = [
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 }
];

const syrupData = [
    { label: "100ml", value: 1 },
    { label: "200ml", value: 2 },
    { label: "300ml ", value: 3 }
];

const powderData = [
    { label: "Pocket 1", value: 1 },
    { label: "Pocket 2", value: 2 },
    { label: "Pocket 3 ", value: 3 }
];

const medicineDayOfUseOptions = [
    { label: "Before Food", value: 1 },
    { label: "After Food", value: 2 }
];

export default function AppointmentModal({ show, handleClose, selectedAction, rowData }) {
    const [state, setState] = useState({
        nextVisitDate: dayjs(),
        errors: {},
        selectStatusValue: "",
        prescriptionMedicineData: [{
            medicineTypeValue: "",
            medicineName: "",
            medicineUseDays: "",
            medicineBeforeAndAfterValue: "",
            medincineQuantityValue: "",
            medicinedayTimingValue: [],
        }],
        validationErrors: [],
    });

    const { selectStatusValue, nextVisitDate, errors, prescriptionMedicineData, validationErrors } = state;


    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

    const handleSelectionChange = (index, field, value) => {
        console.log("asdas", index, field, value);

        const updatedData = state.prescriptionMedicineData.map((item, idx) => (
            idx === index ? { ...item, [field]: value } : item
        ));
        setState({ ...state, prescriptionMedicineData: updatedData });
    };


    const handleAddPrescription = () => {
        setState(prevState => ({
            ...prevState,
            prescriptionMedicineData: [
                ...prevState.prescriptionMedicineData,
                {
                    medicineTypeValue: "",
                    medicineName: "",
                    medicineUseDays: "",
                    medicineBeforeAndAfterValue: "",
                    medincineQuantityValue: "",
                    medicinedayTimingValue: [],
                }
            ],
            validationErrors: [...(prevState.validationErrors || []), {}]
        }));
    };

    const handlePrescriptionDelete = (index) => {
        const updatedData = state.prescriptionMedicineData.filter((_, idx) => idx !== index);
        setState(prevState => ({
            ...prevState,
            prescriptionMedicineData: updatedData,
            validationErrors: [...prevState.validationErrors, {}]
        }));
    };

    const handleChange = (name, value) => {
        let newValue = value;
        setState((prev) => ({
            ...prev,
            [name]: newValue,
            errors: {
                ...prev.errors,
                selectStatusValue: "",
            },
        }));
    };


    const handleDateSubmit = () => {
        if (!nextVisitDate) {
            setState((prev) => ({
                ...prev,
                errors: {
                    ...prev.errors,
                    nextVisitDate: "Please select next visit date",
                },
            }));

            setSnackbar({
                open: true,
                message: "Next visit date is required",
                severity: "error",
            });
            return;
        }
    }

    const handleUpdateStatusSubmit = () => {
        if (!selectStatusValue) {
            setState((prev) => ({
                ...prev,
                errors: {
                    ...prev.errors,
                    selectStatusValue: "Please select a status",
                },
            }));

            setSnackbar({
                open: true,
                message: "Please select a status",
                severity: "error",
            });
            return;
        }
    };

    const onFileChange = async (event) => {
        const files = Array.from(event.target.files);
        try {
            const filesData = await Promise.all(files.map(file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve({ base64Data: reader.result, file });
                reader.onerror = reject;
                reader.readAsDataURL(file);
            })));

        } catch (error) {
            console.error("Error during file upload:", error);
            alert("An error occurred while uploading files. Please try again.");
        }
    };

    return (
        <>
            <Dialog
                open={show}
                onClose={handleClose}
                TransitionComponent={Transition}
                fullWidth
                maxWidth={["reschedule", "prescription"].includes(selectedAction) ? "md" : "xs"}
                keepMounted
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        backgroundColor: "#fdfdfd",
                        boxShadow: 6,
                        mt: 4,
                        alignSelf: "flex-start",
                    },
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        bgcolor: "var(--primary)",
                        color: "#fff",
                        px: 3,
                        py: 1,
                        borderTopLeftRadius: 12,
                        borderTopRightRadius: 12,
                    }}
                >
                    <DialogTitle sx={{ m: 0, p: 0, fontSize: "1.2rem" }}>
                        {selectedAction === "nextVisit" && "Next Visit Date"}
                        {selectedAction === "reschedule" && "Re-schedule Slot"}
                        {selectedAction === "status" && "Update Status"}
                        {selectedAction === "prescription" && "Prescriptions"}
                    </DialogTitle>
                    <IconButton
                        onClick={handleClose}
                        sx={{ color: "#fff" }}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Content */}
                <DialogContent dividers>
                    {selectedAction === "nextVisit" ? (
                        <Grid container spacing={1}>
                            <Grid item size={{ xs: 12, md: 12 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        disablePast
                                        label="Next Visit Date"
                                        value={nextVisitDate}
                                        onChange={(newValue) => {
                                            setState((prev) => ({
                                                ...prev,
                                                nextVisitDate: newValue,
                                                errors: {
                                                    ...prev.errors,
                                                    nextVisitDate: "",
                                                },
                                            }));
                                        }}
                                        slotProps={{
                                            textField: {
                                                fullWidth: true,
                                                error: Boolean(errors.nextVisitDate),
                                                size: 'small',
                                            },
                                            openPickerButton: {
                                                sx: {
                                                    color: "green",
                                                    "& svg": {
                                                        fontSize: "32px", // 👈 icon size
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </Grid>
                        </Grid>
                    ) : selectedAction === "status" ? (
                        <Grid container spacing={1}>
                            <Grid item size={{ xs: 12, md: 12 }}>
                                <SingleSelect
                                    label="Update Status"
                                    name="selectStatusValue"
                                    onChange={handleChange}
                                    options={STATUS_OPTIONS}
                                    value={selectStatusValue}
                                    error={Boolean(errors?.selectStatusValue)}
                                />
                            </Grid>
                        </Grid>
                    ) : selectedAction === "prescription" ? (
                        <Box>
                            <TableContainer
                                component={Paper}
                                sx={{
                                    maxHeight: "50vh",
                                    maxWidth: 1500,          // container width
                                    overflowX: "auto",       // enable horizontal scroll
                                    overflowY: "auto",
                                    WebkitOverflowScrolling: "touch",
                                    scrollbarWidth: "thin"
                                }}
                            >
                                <Table
                                    size="small"
                                    sx={{
                                        minWidth: 1500,      // 👈 force horizontal scroll
                                    }}
                                >
                                    <TableHead sx={{ backgroundColor: "var(--primary)", }}>
                                        <TableRow>
                                            {
                                                [
                                                    { value: 0, label: "#" },
                                                    { value: 1, label: "Medicine Type" },
                                                    { value: 2, label: "Medicine Name" },
                                                    { value: 3, label: `No. of Days  ` },
                                                    { value: 4, label: "Before/After" },
                                                    { value: 4, label: "Quantity" },
                                                    { value: 5, label: "Dosing Schedule" },
                                                    ...state.prescriptionMedicineData.length > 1 ? [{ value: 6, label: "Delete" }] : []
                                                ].map((item, index) => (
                                                    <TableCell key={index} align="center" sx={{ color: "#fff", p: 1.5, fontWeight: "bold", textTransform: "uppercase" }}>
                                                        {item.label}
                                                    </TableCell>
                                                ))
                                            }
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {state.prescriptionMedicineData &&
                                            state.prescriptionMedicineData.length > 0 ? (
                                            state.prescriptionMedicineData.map((field, index) => {
                                                const columns = [
                                                    {
                                                        id: 1,
                                                        name: "medicineTypeValue",
                                                        value: field.medicineTypeValue,
                                                        label: "Select",
                                                        type: "select",
                                                        options: medicineTypes,
                                                    },
                                                    {
                                                        id: 2,
                                                        name: "medicineName",
                                                        value: field.medicineName,
                                                        type: "text",
                                                        placeholder: "Enter Medicine Name",
                                                    },
                                                    {
                                                        id: 3,
                                                        name: "medicineUseDays",
                                                        value: field.medicineUseDays,
                                                        type: "text",
                                                        placeholder: "No. of Days",
                                                    },
                                                    {
                                                        id: 4,
                                                        name: "medicineBeforeAndAfterValue",
                                                        value: field.medicineBeforeAndAfterValue,
                                                        type: "select",
                                                        label: "Select",
                                                        options: medicineDayOfUseOptions,
                                                    },
                                                    {
                                                        id: 5,
                                                        name: "medincineQuantityValue",
                                                        value: field.medincineQuantityValue,
                                                        type: "select",
                                                        label: "Select",
                                                        options: [],
                                                    },
                                                    {
                                                        id: 6,
                                                        name: "medicinedayTimingValue",
                                                        value: field.medicinedayTimingValue,
                                                        type: "multi-select",
                                                        options: prescriptionMedicineDayTimings,
                                                    },
                                                ];

                                                return (
                                                    <TableRow key={index} sx={{ mt: 1 }}>
                                                        {/* Serial No */}
                                                        <TableCell align="center">{index + 1}</TableCell>

                                                        {/* Dynamic Cells */}
                                                        {columns.map((item) => {
                                                            const medicineTypeValue = field?.medicineTypeValue;
                                                            const quantityDataOptions = medicineTypeValue === 1 ? tabletData : medicineTypeValue === 2 ? syrupData : medicineTypeValue === 3 ? powderData : [];
                                                            return (
                                                                <TableCell key={item.id} align="center">
                                                                    {item.type === "select" && (
                                                                        <FormControl fullWidth size="small">
                                                                            <InputLabel>{item.label}</InputLabel>
                                                                            <Select
                                                                                label={item.label}
                                                                                name={item.name}
                                                                                value={item.value || ""}
                                                                                onChange={(e) =>
                                                                                    handleSelectionChange(index, item.name, e.target.value)
                                                                                }
                                                                            >
                                                                                {(item.name === "medincineQuantityValue" ? quantityDataOptions : item.options || []).map((opt, i) => (
                                                                                    <MenuItem key={i} value={opt.value}>
                                                                                        {opt.label}
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                        </FormControl>
                                                                    )}

                                                                    {item.type === "text" && (
                                                                        <TextField
                                                                            value={item.value || ""}
                                                                            placeholder={item.placeholder}
                                                                            size="small"
                                                                            fullWidth
                                                                            onChange={(e) =>
                                                                                handleSelectionChange(index, item.name, [2].includes(item.id) ? e.target.value : e.target.value.replace(/\D/g, "").slice(0, 50))
                                                                            }
                                                                        />
                                                                    )}

                                                                    {item.type === "multi-select" && (
                                                                        <FormControl fullWidth size="small">
                                                                            <InputLabel>Dosing Schedules</InputLabel>

                                                                            <Select
                                                                                multiple
                                                                                value={item.value || []}
                                                                                label="Dosing Schedules"
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;

                                                                                    // If "selectAll" clicked
                                                                                    if (value[value.length - 1] === "selectAll") {
                                                                                        const allSelected =
                                                                                            (item.value || []).length === item.options.length;

                                                                                        handleSelectionChange(
                                                                                            index,
                                                                                            item.name,
                                                                                            allSelected ? [] : item.options
                                                                                        );
                                                                                        return;
                                                                                    }

                                                                                    handleSelectionChange(index, item.name, value);
                                                                                }}
                                                                                renderValue={(selected) =>
                                                                                    selected.map((opt) => opt.label).join(", ")
                                                                                }
                                                                            >
                                                                                {/* Select All */}
                                                                                <MenuItem value="selectAll">
                                                                                    <Checkbox
                                                                                        checked={
                                                                                            item.options.length > 0 &&
                                                                                            (item.value || []).length === item.options.length
                                                                                        }
                                                                                        indeterminate={
                                                                                            (item.value || []).length > 0 &&
                                                                                            (item.value || []).length < item.options.length
                                                                                        }
                                                                                    />
                                                                                    <ListItemText primary="Select All" />
                                                                                </MenuItem>

                                                                                {/* Options */}
                                                                                {item.options.map((option) => (
                                                                                    <MenuItem key={option.value} value={option}>
                                                                                        <Checkbox
                                                                                            checked={(item.value || []).some(
                                                                                                (v) => v.value === option.value
                                                                                            )}
                                                                                        />
                                                                                        <ListItemText primary={option.label} />
                                                                                    </MenuItem>
                                                                                ))}
                                                                            </Select>
                                                                        </FormControl>
                                                                    )}
                                                                </TableCell>
                                                            )
                                                        })}

                                                        {/* Delete */}
                                                        <TableCell align="center">
                                                            {state.prescriptionMedicineData.length > 1 && (
                                                                <Tooltip title="Delete">
                                                                    <Button
                                                                        onClick={() => handlePrescriptionDelete(index)}
                                                                    >
                                                                        <DeleteForeverIcon color="error" />
                                                                    </Button>
                                                                </Tooltip>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={8} align="center">
                                                    No prescription data available
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <Grid container spacing={1} mt={2} justifyContent="flex-end">
                                <Grid item size={{ xs: 12, md: 2 }}>
                                    <Tooltip title="Add Row">
                                        <CustomButton
                                            status={false}
                                            onClick={handleAddPrescription}
                                            label="Add"
                                            loadingLabel="Submitting.."
                                        />
                                    </Tooltip>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                {
                                    [
                                        { id: 1, label: 'Comments', placeholder: 'Comments', rows: 1, name: "comments", value: state.prescriptionComments, type: 'textarea' },
                                        { id: 2, label: 'Upload Files', type: 'file', multiple: true, }
                                    ].map((field) => (
                                        <Grid item size={{ xs: 12, md: 6 }} key={field.id}>
                                            {/* Label */}
                                            <Typography variant="subtitle2" gutterBottom>
                                                {field.id === 2 && state.isLoaderFile ? (
                                                    <Box display="flex" alignItems="center" gap={1} color="success.main">
                                                        <CircularProgress size={16} />
                                                        Updating Files...
                                                    </Box>
                                                ) : (
                                                    field.label
                                                )}
                                            </Typography>

                                            {/* Textarea */}
                                            {field.type === "textarea" ? (
                                                <TextField
                                                    multiline
                                                    rows={field.rows}
                                                    placeholder={field.placeholder}
                                                    value={field.value}
                                                    fullWidth
                                                    size="small"
                                                    onChange={(e) =>
                                                        setState({
                                                            ...state,
                                                            prescriptionComments: e.target.value,
                                                        })
                                                    }
                                                />
                                            ) : (
                                                /* File / Other Inputs */
                                                <TextField
                                                    type={field.type}
                                                    fullWidth
                                                    size="small"
                                                    inputProps={{
                                                        multiple: field.multiple,
                                                    }}
                                                    onChange={onFileChange}
                                                />
                                            )}
                                        </Grid>
                                    ))
                                }
                            </Grid>
                        </Box>
                    ) : null}
                </DialogContent>

                <DialogActions>
                    {
                        selectedAction === "nextVisit" ? (
                            <CustomButton
                                status={false}
                                onClick={handleDateSubmit}
                                label="Next Vist"
                                loadingLabel="Submitting.."
                            />
                        ) : selectedAction === "status" ? (
                            <CustomButton
                                status={false}
                                onClick={handleUpdateStatusSubmit}
                                label="Update Staus"
                                loadingLabel="Submitting.."
                            />
                        ) : selectedAction === "prescription" ? (
                            <CustomButton
                                status={false}
                                label="Submit"
                                loadingLabel="Submitting.."
                            />
                        ) : null
                    }
                </DialogActions>
            </Dialog >

            <SnackbarMessage open={snackbar.open} message={snackbar.message} severity={snackbar.severity} onClose={() => setSnackbar(prev => ({ ...prev, open: false }))} />
        </>
    );
}